export default [
    {
        path: 'index'
    },
    {
        path: 'game'
    },
    {
        path: 'shop'
    },
    {
        path: 'clan'
    },
    {
        path: 'rank'
    },
    {
        path: 'record'

    },
    {
        path: 'prize'
    },
    {
        path: 'data',
        component: () => import('@/pages/isle/data')
    },
    {
        path: 'active',
        component: () => import('@/pages/isle/active')
    },
    {
        path: 'dino-hatch',
        component: () => import('@/pages/isle/dino')
    },
    {
        path: 'pvp',
        component: () => import('@/pages/isle/pvp')
    },
    {
        path: 'routes',
        meta: {
            role: 2
        },
        component: () => import('@/pages/isle/routes')
    },
    {
        path: 'map',
        component: () => import('@/pages/isle/map')
    }
];
